/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./resources/app.ts":
/*!**************************!*\
  !*** ./resources/app.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _components_DataLayer_DataLayer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @components/DataLayer/DataLayer */ "./resources/scripts/components/DataLayer/DataLayer.ts");
/* harmony import */ var _components_discountNinja__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @components/discountNinja */ "./resources/scripts/components/discountNinja.ts");


var editionDataLayer = new _components_DataLayer_DataLayer__WEBPACK_IMPORTED_MODULE_0__["default"]();
editionDataLayer.init();
var discountNinja = new _components_discountNinja__WEBPACK_IMPORTED_MODULE_1__["default"]();
discountNinja.init();

/***/ }),

/***/ "./resources/scripts/components/DataLayer/AccountRegister.ts":
/*!*******************************************************************!*\
  !*** ./resources/scripts/components/DataLayer/AccountRegister.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ AccountRegister)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Datalayer Account Register
var AccountRegister = /*#__PURE__*/function () {
  function AccountRegister() {
    _classCallCheck(this, AccountRegister);
    _defineProperty(this, "dataLayer", window.dataLayer);
    this.init = this.init.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.pushAccountRegisterEvent = this.pushAccountRegisterEvent.bind(this);
    this.pushNewsLetterSubscribeEvent = this.pushNewsLetterSubscribeEvent.bind(this);
  }
  return _createClass(AccountRegister, [{
    key: "init",
    value: function init() {
      var _this = this;
      var accountRegisterForms = Array.from(document.querySelectorAll('form[action="/account"]'));
      if (accountRegisterForms.length >= 1) {
        accountRegisterForms.forEach(function (form) {
          form.addEventListener('submit', function () {
            _this.handleSubmit(form);
          });
        });
      }
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(form) {
      var firstNameInput = form.querySelector('input[name="customer[first_name]"');
      var lastNameInput = form.querySelector('input[name="customer[last_name]"');
      var emailInput = form.querySelector('input[name="customer[email]"');
      var acceptsMarketingInput = form.querySelector('input[name="customer[accepts_marketing]"');
      var noteInputs = document.querySelectorAll('input[name^="customer[note]"]');
      var notes = [];
      var firstName = firstNameInput ? firstNameInput.value || '' : '';
      var lastName = lastNameInput ? lastNameInput.value || '' : '';
      var email = emailInput ? emailInput.value || '' : '';
      var acceptsMarketing = acceptsMarketingInput && acceptsMarketingInput.checked !== undefined ? acceptsMarketingInput.checked : false;
      if (noteInputs.length >= 1) {
        notes = Array.from(noteInputs).map(function (noteInput) {
          if (noteInput.value === '') return undefined;
          var noteFieldName = noteInput.name.split('customer[note]')[1] || '';
          noteFieldName = noteFieldName.replace('[', '').replace(']', '');
          return "".concat(noteFieldName, ": ").concat(noteInput.value);
        }).filter(function (note) {
          return note !== undefined;
        });
      }
      // Capturing the event in the accountRegisterEventObject
      var accountRegisterEventObject = {
        event: 'edition_account_register',
        signUpMethod: 'email',
        customerFirstName: firstName,
        customerLastName: lastName,
        customerEmail: email,
        acceptsMarketing: acceptsMarketing,
        customerNotes: notes
      };
      this.pushAccountRegisterEvent(accountRegisterEventObject);
      if (acceptsMarketing) {
        var newsLetterSubscribeEventObject = {
          event: 'edition_newsletter_subscribe',
          customerEmail: email
        };
        this.pushNewsLetterSubscribeEvent(newsLetterSubscribeEventObject);
      }
    }
  }, {
    key: "pushAccountRegisterEvent",
    value: function pushAccountRegisterEvent(accountRegisterEventObject) {
      this.dataLayer.push(accountRegisterEventObject);
    }
  }, {
    key: "pushNewsLetterSubscribeEvent",
    value: function pushNewsLetterSubscribeEvent(newsLetterSubscribeEventObject) {
      this.dataLayer.push(newsLetterSubscribeEventObject);
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/DataLayer/AddToWishlist.ts":
/*!*****************************************************************!*\
  !*** ./resources/scripts/components/DataLayer/AddToWishlist.ts ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ProductAddToWishlist)
/* harmony export */ });
/* harmony import */ var _utils_DatalayerHelpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../utils/DatalayerHelpers */ "./resources/scripts/utils/DatalayerHelpers.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Datalayer Add to Wishlist
// TODO

var ProductAddToWishlist = /*#__PURE__*/function () {
  function ProductAddToWishlist() {
    _classCallCheck(this, ProductAddToWishlist);
    _defineProperty(this, "addedToWishListEvent", 'Edition:AddedToWishlist');
    _defineProperty(this, "dataLayer", window.dataLayer);
    this.init = this.init.bind(this);
    this.listenForAddToWishlist = this.listenForAddToWishlist.bind(this);
  }
  return _createClass(ProductAddToWishlist, [{
    key: "init",
    value: function init() {
      this.listenForAddToWishlist();
    }
  }, {
    key: "listenForAddToWishlist",
    value: function listenForAddToWishlist() {
      var _this = this;
      document.addEventListener(this.addedToWishListEvent, function (event) {
        var details = event.detail;
        _this.pushAddToWishlistEvent(details);
      });
    }
  }, {
    key: "pushAddToWishlistEvent",
    value: function pushAddToWishlistEvent(details) {
      this.dataLayer.push({
        ecommerce: null
      });
      var addToWishlistEventObject = {
        event: 'edition_add_to_wishlist',
        ecommerce: {
          currency: window.Shopify.currency.active,
          value: 1,
          items: [{
            item_name: details.title,
            item_id: details.id,
            item_handle: details.handle,
            item_url: details.url
          }]
        }
      };
      (0,_utils_DatalayerHelpers__WEBPACK_IMPORTED_MODULE_0__["default"])(addToWishlistEventObject);
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/DataLayer/ContactFormSubmit.ts":
/*!*********************************************************************!*\
  !*** ./resources/scripts/components/DataLayer/ContactFormSubmit.ts ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ContactFormSubmit)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Datalayer Contact Form Submit
var ContactFormSubmit = /*#__PURE__*/function () {
  function ContactFormSubmit() {
    _classCallCheck(this, ContactFormSubmit);
    _defineProperty(this, "dataLayer", window.dataLayer);
    this.init = this.init.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.pushContactFormSubmitEventObject = this.pushContactFormSubmitEventObject.bind(this);
  }
  return _createClass(ContactFormSubmit, [{
    key: "init",
    value: function init() {
      var _this = this;
      // Get all contact forms that have more than one input field that is not hidden
      var contactForms = Array.from(document.querySelectorAll('form[action^="/contact"]')).filter(function (form) {
        return form.querySelectorAll('input:not([type="hidden"]), textarea').length > 1;
      });
      contactForms.forEach(function (form) {
        form.addEventListener('submit', function () {
          _this.handleSubmit(form);
        });
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(form) {
      var firstNameInput = form.querySelector('input[name="contact[Name]"');
      var emailInput = form.querySelector('input[name="contact[email]"]');
      var phoneInput = form.querySelector('input[name="contact[Phone number]"]');
      var firstName = firstNameInput ? firstNameInput.value || '' : '';
      var email = emailInput ? emailInput.value || '' : '';
      var phone = phoneInput ? phoneInput.value || '' : '';
      // Capturing the event in the contactFormSubmitEventObject
      var contactFormSubmitEventObject = {
        event: 'edition_contact_form_submit',
        customerFirstName: firstName,
        customerEmail: email,
        customerPhone: phone
      };
      this.pushContactFormSubmitEventObject(contactFormSubmitEventObject);
    }
  }, {
    key: "pushContactFormSubmitEventObject",
    value: function pushContactFormSubmitEventObject(contactFormSubmitEventObject) {
      this.dataLayer.push(contactFormSubmitEventObject);
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/DataLayer/DataLayer.ts":
/*!*************************************************************!*\
  !*** ./resources/scripts/components/DataLayer/DataLayer.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ EditionDataLayer)
/* harmony export */ });
/* harmony import */ var _Login__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Login */ "./resources/scripts/components/DataLayer/Login.ts");
/* harmony import */ var _AccountRegister__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./AccountRegister */ "./resources/scripts/components/DataLayer/AccountRegister.ts");
/* harmony import */ var _ContactFormSubmit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./ContactFormSubmit */ "./resources/scripts/components/DataLayer/ContactFormSubmit.ts");
/* harmony import */ var _NewsletterSubscribe__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./NewsletterSubscribe */ "./resources/scripts/components/DataLayer/NewsletterSubscribe.ts");
/* harmony import */ var _AddToWishlist__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./AddToWishlist */ "./resources/scripts/components/DataLayer/AddToWishlist.ts");
/* harmony import */ var _MediaInteractions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./MediaInteractions */ "./resources/scripts/components/DataLayer/MediaInteractions.ts");
/* harmony import */ var _SessionDurationLogger__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./SessionDurationLogger */ "./resources/scripts/components/DataLayer/SessionDurationLogger.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }







var EditionDataLayer = /*#__PURE__*/function () {
  function EditionDataLayer() {
    _classCallCheck(this, EditionDataLayer);
    _defineProperty(this, "login", new _Login__WEBPACK_IMPORTED_MODULE_0__["default"]());
    _defineProperty(this, "accountRegister", new _AccountRegister__WEBPACK_IMPORTED_MODULE_1__["default"]());
    _defineProperty(this, "contactFormSubmit", new _ContactFormSubmit__WEBPACK_IMPORTED_MODULE_2__["default"]());
    _defineProperty(this, "newsletterSubscribe", new _NewsletterSubscribe__WEBPACK_IMPORTED_MODULE_3__["default"]());
    _defineProperty(this, "addToWishlist", new _AddToWishlist__WEBPACK_IMPORTED_MODULE_4__["default"]());
    _defineProperty(this, "mediaInteractions", new _MediaInteractions__WEBPACK_IMPORTED_MODULE_5__["default"]());
    _defineProperty(this, "sessionDurationLogger", new _SessionDurationLogger__WEBPACK_IMPORTED_MODULE_6__["default"]());
    this.init = this.init.bind(this);
  }
  return _createClass(EditionDataLayer, [{
    key: "init",
    value: function init() {
      var _this = this;
      setTimeout(function () {
        _this.login.init();
        _this.accountRegister.init();
        _this.contactFormSubmit.init();
        _this.newsletterSubscribe.init();
        _this.addToWishlist.init();
        _this.mediaInteractions.init();
        _this.sessionDurationLogger.init();
      }, 1000);
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/DataLayer/Login.ts":
/*!*********************************************************!*\
  !*** ./resources/scripts/components/DataLayer/Login.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Login)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Datalayer Login
var Login = /*#__PURE__*/function () {
  function Login() {
    _classCallCheck(this, Login);
    _defineProperty(this, "dataLayer", window.dataLayer);
    this.init = this.init.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.pushLoginEvent = this.pushLoginEvent.bind(this);
  }
  return _createClass(Login, [{
    key: "init",
    value: function init() {
      var _this = this;
      var loginForms = Array.from(document.querySelectorAll('form[action="/account/login"]'));
      if (loginForms.length >= 1) {
        loginForms.forEach(function (form) {
          form.addEventListener('submit', function () {
            _this.handleSubmit(form);
          });
        });
      }
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(form) {
      var emailInput = form.querySelector('input[type="email"]');
      var email = emailInput.value || '';
      // Capturing the event in the loginEventObject
      var loginEventObject = {
        event: 'edition_login',
        loginMethod: 'email',
        customerEmail: email
      };
      this.pushLoginEvent(loginEventObject);
    }
  }, {
    key: "pushLoginEvent",
    value: function pushLoginEvent(loginEventObject) {
      this.dataLayer.push(loginEventObject);
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/DataLayer/MediaInteractions.ts":
/*!*********************************************************************!*\
  !*** ./resources/scripts/components/DataLayer/MediaInteractions.ts ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ MediaInteractions)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable */
// DataLayer Media Interactions
var MediaInteractions = /*#__PURE__*/function () {
  function MediaInteractions() {
    _classCallCheck(this, MediaInteractions);
    _defineProperty(this, "dataLayer", window.dataLayer);
    this.init = this.init.bind(this);
    this.listenForMediaInteractions = this.listenForMediaInteractions.bind(this);
  }
  return _createClass(MediaInteractions, [{
    key: "init",
    value: function init() {
      var _this = this;
      setTimeout(function () {
        _this.listenForMediaInteractions();
      }, 1000);
    }
  }, {
    key: "listenForMediaInteractions",
    value: function listenForMediaInteractions() {
      var mediaElements = Array.from(document.querySelectorAll('video, audio'));
      mediaElements.forEach(function (mediaElement) {
        mediaElement.addEventListener('play', function (event) {
          /* console.log('Media Play Event', event); */
        });
        mediaElement.addEventListener('pause', function (event) {
          /* console.log('Media Pause Event', event); */
        });
        mediaElement.addEventListener('volumechange', function (event) {
          /* if (mediaElement.muted) {
            console.log('Media Mute Event', event);
          } */
        });
      });
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/DataLayer/NewsletterSubscribe.ts":
/*!***********************************************************************!*\
  !*** ./resources/scripts/components/DataLayer/NewsletterSubscribe.ts ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ NewsletterSubscribe)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Datalayer Newsletter Subscribe
var NewsletterSubscribe = /*#__PURE__*/function () {
  function NewsletterSubscribe() {
    _classCallCheck(this, NewsletterSubscribe);
    _defineProperty(this, "dataLayer", window.dataLayer);
    this.init = this.init.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.pushNewsletterSubscribeEventObject = this.pushNewsletterSubscribeEventObject.bind(this);
  }
  return _createClass(NewsletterSubscribe, [{
    key: "init",
    value: function init() {
      var _this = this;
      // Get all newsletter forms that only one input field that is not hidden
      var newsletterSubscribeForms = Array.from(document.querySelectorAll('form[action^="/contact"]')).filter(function (form) {
        return form.querySelectorAll('input:not([type="hidden"]), textarea').length === 1;
      });
      newsletterSubscribeForms.forEach(function (form) {
        form.addEventListener('submit', function () {
          _this.handleSubmit(form);
        });
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(form) {
      var emailInput = form.querySelector('input[name="contact[email]"]');
      var email = emailInput ? emailInput.value || '' : '';
      // Capturing the event in the newsletterSubscribeEventObject
      var newsletterSubscribeEventObject = {
        event: 'edition_newsletter_subscribe',
        customerEmail: email
      };
      this.pushNewsletterSubscribeEventObject(newsletterSubscribeEventObject);
    }
  }, {
    key: "pushNewsletterSubscribeEventObject",
    value: function pushNewsletterSubscribeEventObject(newsletterSubscribeEventObject) {
      this.dataLayer.push(newsletterSubscribeEventObject);
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/DataLayer/SessionDurationLogger.ts":
/*!*************************************************************************!*\
  !*** ./resources/scripts/components/DataLayer/SessionDurationLogger.ts ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ SessionDurationLogger)
/* harmony export */ });
/* harmony import */ var _utils_DatalayerHelpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../utils/DatalayerHelpers */ "./resources/scripts/utils/DatalayerHelpers.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Import pushToDataLayer helper function (as in your example)

// Define the custom web component class
var SessionDurationLogger = /*#__PURE__*/function () {
  function SessionDurationLogger() {
    _classCallCheck(this, SessionDurationLogger);
    _defineProperty(this, "maxTime", 300);
    _defineProperty(this, "logInterval", 30);
    _defineProperty(this, "lastLoggedTime", 0);
    _defineProperty(this, "intervalID", null);
    this.init = this.init.bind(this);
    this.startLogging = this.startLogging.bind(this);
    this.logElapsedTime = this.logElapsedTime.bind(this);
  }
  // Store the session start time if not already stored
  return _createClass(SessionDurationLogger, [{
    key: "init",
    value: function init() {
      if (!sessionStorage.getItem('gtm_session_start')) {
        sessionStorage.setItem('gtm_session_start', Date.now().toString());
      }
      this.startLogging();
    }
    // Function to start the interval timer for logging session duration
  }, {
    key: "startLogging",
    value: function startLogging() {
      var _this = this;
      this.intervalID = setInterval(function () {
        return _this.logElapsedTime();
      }, 1000); // Keep this if logging every second is needed
    }
    // Function to check elapsed time and log it if needed
  }, {
    key: "logElapsedTime",
    value: function logElapsedTime() {
      var startTime = parseInt(sessionStorage.getItem('gtm_session_start'), 10) || Date.now();
      var currentTime = Date.now();
      var elapsedTime = currentTime - startTime;
      var elapsedSeconds = Math.floor(elapsedTime / 1000);
      if (elapsedSeconds % this.logInterval === 0 && elapsedSeconds !== this.lastLoggedTime && elapsedSeconds <= this.maxTime) {
        // Prepare the dataLayer event object
        var eventObject = {
          event: 'engaged_session',
          session_duration: elapsedSeconds
        };
        // Push the event to the dataLayer
        (0,_utils_DatalayerHelpers__WEBPACK_IMPORTED_MODULE_0__["default"])(eventObject);
        // Update the last logged time
        this.lastLoggedTime = elapsedSeconds;
      }
      // Stop logging if the maximum time has been reached
      if (elapsedSeconds > this.maxTime) {
        clearInterval(this.intervalID);
        this.intervalID = null; // Reset to avoid stale references
      }
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/components/discountNinja.ts":
/*!*******************************************************!*\
  !*** ./resources/scripts/components/discountNinja.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ DiscountNinja)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DiscountNinja = /*#__PURE__*/function () {
  function DiscountNinja() {
    _classCallCheck(this, DiscountNinja);
    _defineProperty(this, "updatingCart", false);
    _defineProperty(this, "cartEvents", ["cart:item-added", "line-item:change:start"]);
    this.init = this.init.bind(this);
  }
  return _createClass(DiscountNinja, [{
    key: "init",
    value: function init() {
      var _this = this;
      document.addEventListener("la:dn:api:ready", function () {
        _this.initDiscountNinja();
      });
    }
  }, {
    key: "initDiscountNinja",
    value: function initDiscountNinja() {
      this.addDiscountNinjaEventListeners();
    }
  }, {
    key: "addDiscountNinjaEventListeners",
    value: function addDiscountNinjaEventListeners() {
      var _this2 = this;
      this.cartEvents.forEach(function (eventName) {
        document.addEventListener(eventName, function (event) {
          _this2.setCartLoadingState(true);
          // Set a timeout for the case where la:dn:cart:discounted doesn't fire
          var fallbackTimeout = setTimeout(function () {
            document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
              bubbles: true
            }));
            _this2.setCartLoadingState(false);
          }, 3000); // 3 second timeout
          // listen for the discount ninja la:dn:cart:updated
          document.addEventListener("la:dn:cart:discounted", function () {
            clearTimeout(fallbackTimeout); // Cancel the fallback timeout
            setTimeout(function () {
              document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                bubbles: true
              }));
              _this2.setCartLoadingState(false);
            }, 500);
          }, {
            once: true
          });
        });
      });
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "setCartLoadingState",
    value: function setCartLoadingState(isLoading) {
      var cartDrawer = document.querySelector("cart-drawer");
      if (!cartDrawer) {
        return;
      }
      var loader = cartDrawer.querySelector(".cart-drawer__loader");
      if (!loader) {
        return;
      }
      // Show or hide the loader based on the isLoading state
      loader.style.display = isLoading ? "flex" : "none";
    }
  }]);
}();


/***/ }),

/***/ "./resources/scripts/utils/DatalayerHelpers.ts":
/*!*****************************************************!*\
  !*** ./resources/scripts/utils/DatalayerHelpers.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ pushToDataLayer)
/* harmony export */ });
window.dataLayer = window.dataLayer || [];
// Function to push the event to the datalayer.
// If something goes wrong and the event does not get pushed, we check again after a set interval and try to push again.
function pushToDataLayer(object) {
  window.dataLayer.push(object);
  var intervalId = setInterval(function () {
    var isEventPushed = window.dataLayer.includes(object);
    if (!isEventPushed) {
      window.dataLayer.push(object);
    } else {
      clearInterval(intervalId);
    }
  }, 750);
}

/***/ }),

/***/ "./resources/styles/app.css":
/*!**********************************!*\
  !*** ./resources/styles/app.css ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/shopify-theme/assets/edition": 0,
/******/ 			"shopify-theme/assets/edition": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkelvstroem"] = self["webpackChunkelvstroem"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["shopify-theme/assets/edition"], () => (__webpack_require__("./resources/app.ts")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["shopify-theme/assets/edition"], () => (__webpack_require__("./resources/styles/app.css")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;